<template>
  <PageTemplate>
    <v-container class="pb-8 pb-md-12 pb-lg-16 overflow-hidden">
      <v-row justify="center">
        <v-col v-if="vacancies.length" cols="12" class="pt-10">
          <Title class="text-center mb-6 mb-lg-8"> Vagas Disponíveis </Title>

          <div class="mt-8 mt-md-10 justify-center vacancies-list">
            <template
              v-for="(
                { id, title, requirements, remuneration, benefits },
                keyVacancies
              ) in vacancies"
            >
              <v-card
                :key="keyVacancies"
                @click="goTo(id)"
                class="pa-5 elevation-8"
                height="auto"
              >
                <div class="primary--text text-h6 text-md-h5 font-weight-bold">
                  {{ title }}
                </div>

                <template v-if="requirements.length">
                  <div
                    class="
                      grey--text
                      text--darken-3 text-subtitle-1
                      font-weight-bold
                      mt-2
                    "
                  >
                    Requisitos
                  </div>

                  <template v-for="requirement in requirements">
                    <div
                      :key="requirement"
                      class="grey--text text--darken-2 text-body-1"
                    >
                      - {{ requirement }}
                    </div>
                  </template>
                </template>

                <template v-if="remuneration">
                  <div
                    class="
                      grey--text
                      text--darken-3 text-h6
                      font-weight-bold
                      mt-2
                    "
                  >
                    Remuneração:
                    <span class="grey--text text--darken-2 text-body-1">
                      {{ remuneration }}
                    </span>
                  </div>
                </template>

                <template v-if="benefits.length">
                  <div
                    class="
                      grey--text
                      text--darken-3 text-subtitle-1
                      font-weight-bold
                      mt-2
                    "
                  >
                    Benefícios
                  </div>

                  <template v-for="benefit in benefits">
                    <div
                      :key="benefit"
                      class="grey--text text--darken-2 text-body-1"
                    >
                      - {{ benefit }}
                    </div>
                  </template></template
                >
              </v-card>
            </template>
          </div>
        </v-col>

        <v-col id="envie-seu-curriculo" class="pt-10" cols="12" md="7" lg="6">
          <Title class="text-center mb-6 mb-lg-8">Envie seu Currículo</Title>
          <Form />
        </v-col>

        <v-col cols="12">
          <div class="d-flex justify-center mx-n5">
            <v-btn
              rounded
              depressed
              height="40px"
              min-width="auto"
              width="40px"
              :href="link"
              target="_blank"
              class="secondary--text text--lighten-1 ml-2"
              :title="title"
              text
              v-for="({ title, link, icon, size }, keySocial) in media"
              :key="keySocial"
            >
              <v-icon :size="size"> {{ icon }} </v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </PageTemplate>
</template>

<script>
import { getSocial } from "../../config";
import PageTemplate from "../templates/Page.vue";
import Title from "../widgets/Title.vue";
import Form from "../forms/WorkWithUs.vue";

export default {
  created() {
    const medias = this.$rest("informations-medias").get({
      save: (state, data) => (state.item = data),
    });

    const vacancies = this.$rest("vacancies").get();

    Promise.all([medias, vacancies]).finally(() => (this.loading = false));
  },
  computed: {
    medias() {
      return this.$rest("informations-medias").item;
    },
    media() {
      return getSocial(this.medias);
    },
    vacancies() {
      return this.$rest("vacancies").list.map(
        ({ id, title, requirements, remuneration, benefits }) => ({
          id,
          title,
          requirements:
            requirements && JSON.parse(requirements).length
              ? JSON.parse(requirements)
              : [],
          remuneration,
          benefits:
            benefits && JSON.parse(benefits).length ? JSON.parse(benefits) : [],
        })
      );
    },
  },
  methods: {
    goTo(v) {
      this.$router.push({ hash: "envie-seu-curriculo", query: { vaga: v } });
    },
  },
  components: {
    PageTemplate,
    Title,
    Form,
  },
};
</script>

<style lang="scss">
.vacancies-list {
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(auto-fit, 300px);
}
</style>
